import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup
} from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import DatePickerGeneric from '../../Components/generic/DatePickerGeneric';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import ListaNotasClientePage from './ListaNotasClientePage';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import { NOTA_MODELO_NFE, NOTA_MODELO_NFSE } from '../../constants';
import EdRadio from '../../Generic/EdRadio';

const NotasClientePage: React.FC = () => {
  const [dataInicio, setDataInicio] = useState(dayjs().startOf('month'));
  const [dataFim, setDataFim] = useState(dayjs().endOf('month'));
  const [tipoNota, setTipoNota] = useState<'55' | 'PS' | null>(null);
  const [sessao] = useSessao();
  const [buscarNota, setBuscarNota] = useState(false);

  const opcoesTipoNota = [
    ...(sessao.empresa?.nfe ? [{ label: 'Nota Fiscal Eletrônica', value: NOTA_MODELO_NFE }] : []),
    ...(sessao.empresa?.nfs ? [{ label: 'Nota Fiscal de Serviço', value: NOTA_MODELO_NFSE }] : [])
  ];

  useEffect(() => {
    if (opcoesTipoNota.length === 1) {
      setTipoNota(opcoesTipoNota[0].value as '55' | 'PS');
    } else if (opcoesTipoNota.length === 0) {
      setTipoNota(null);
    }
  }, [sessao.empresa]);

  if (!sessao.empresa?.clientePodeVisualizarNfe) {
    return (
      <div>
        <Typography variant="h5" component="h1" gutterBottom>
          Notas Fiscais
        </Typography>

        <Typography variant="body1" color="textSecondary">
          O acesso às notas fiscais não está habilitado para o seu usuário. Para liberar essa
          funcionalidade, entre em contato com a nossa equipe.
        </Typography>
      </div>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" component="h1">
          Notas Fiscais
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <DatePickerGeneric
          label={'Data inicial'}
          value={dataInicio}
          setValue={(value) => setDataInicio(value)}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <DatePickerGeneric
          label={'Data final'}
          value={dataFim}
          setValue={(value) => setDataFim(value)}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={6}>
        {opcoesTipoNota.length > 0 && tipoNota ? (
          <EdRadio
            label="Tipo de Nota"
            direction="row"
            options={opcoesTipoNota}
            value={tipoNota}
            onChange={(e) => setTipoNota(e as '55' | 'PS')}
          />
        ) : (
          <Typography variant="body2" color="textSecondary">
            Nenhum tipo de nota está habilitado para esta empresa.
          </Typography>
        )}
      </Grid>

      <Grid item xs={12} display="flex" justifyContent="center">
        <Button variant="contained" onClick={() => setBuscarNota(true)}>
          Buscar
        </Button>
      </Grid>

      {tipoNota && (
        <Grid item xs={12}>
          <ListaNotasClientePage
            dataInicio={dataInicio}
            dataFim={dataFim}
            tipoNota={tipoNota}
            buscarNota={buscarNota}
            onBuscaConcluida={() => setBuscarNota(false)}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default NotasClientePage;
